import axios from "axios";
import { logout } from "../lib/auth";
import { highRankCompanyTableColumn } from "../config/highRankCompany";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 上位店一覧
export async function getHighRankCompanys(props: {
  [key: string]: number | string;
}) {
  try {
    const path = "highRankCompanys";
    const params = makeParams(highRankCompanyTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const highRankCompanys: dataDifine[] = response.data.fetch_data;
    const countHighRankCompanys: string = response.data.count_data;
    return { highRankCompanys, countHighRankCompanys };
  } catch (error) {
    // logout();
  }
}

// 上位店詳細
export async function getHighRankCompany(id: string) {
  try {
    const path = "highRankCompany";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {
    // logout();
    return { option_data: [] };
  }
}

// 上位店編集
export async function putHighRankCompany(editData: EditDataDifine) {
  try {
    const path = "highRankCompany";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 上位店情報登録
export async function postHighRankCompany(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "highRankCompany";
    const bodys = addData;
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
